import { Icon, DivIcon, Marker } from 'leaflet';

import 'moment/locale/pt-br.js';
import moment from 'moment';

import { getCameraThumb } from '../../util/camera';

const TIME = 50000;

const AbstractMarker = (coordenadas, options, iconUrl, retinaIconUrl, usuario, onClick) => {
  const icon = new Icon({
    iconUrl: iconUrl,
    //iconRetinaUrl: retinaIconUrl,
    iconSize:     [33, 51],
    popupAnchor: [0, -50],
    iconAnchor:   [22, 68]
  });

  var marker = new Marker(coordenadas, { ...options, icon });

  if(options.alerta){
    if(moment().diff(moment(options.alerta.data)) < TIME){
      marker = new Marker(coordenadas, { ...options, icon, id: 'pulse-marker' });
    }
  }
  
  if (onClick) {
    marker.on('click', onClick);
  }
  if (options.alerta) {
    if(usuario){
      if(!usuario.hasOwnProperty("avatar") || !usuario.avatar){
        usuario.avatar = "/images/avatar.svg";
      }
      if(!options.alerta.endereco){
        options.alerta.endereco = "Não foi possível recuperar a localização.";
      }
      marker.bindPopup(
        `
          <style>
          .leaflet-popup-content-wrapper {
            background-color: #a81418;
          }
          .leaflet-popup-content {
            width: 600px;
            margin: -1px;
          }
          </style>

          <div style="top: 7rem; background-color: #ffffff; border-radius: 10px;">
            <h4 class="card-title" style="text-align: center; background-color: #a81418; padding-bottom: 15px; color: #ffffff">${options.alerta.tipo}</h4>
            <div style="padding: 15px 20px">
              <div style="display: flex;">
                
                <img style="width:50px; height:50px; border-radius: 50%; margin-top: 9px;" src="${usuario.avatar}" />
                
                <div style="line-height: 23px; color: #000000; margin-left: 17px;">
                  <div style="font-weight: bold; font-size: 15px;" >${usuario.nome}</div>
                  <div>${usuario.telefone}</div>
                  <div>${usuario.email}</div>
                </div>
              </div>
              <hr style="border-color: #a81418">
              <div style="color: #000000;">
                <div>${options.alerta.endereco}</div>
              </div>
              <hr style="border-color: #a81418">
              <div style="text-align: center; color: #a81418; font-weight: bold; font-size: 16px;">
                <div>${moment(options.alerta.data).fromNow()}</div>
              </div>
            </div>
          </div>
        `
      );

      marker.bindTooltip(() => {
        return `<style>
        .leaflet-tooltip-top {
          background-color: rgb(0, 89, 108, 0.9);
          color: #ffffff;
          border: none;
          margin-top: -67px;
          margin-left: -6px;
          width: auto;
        }

        .leaflet-tooltip-top:before {
          border: none;
        }

        .leaflet-tooltip-top p {
          font-size: 12px;
          margin-bottom: 0px;
        }
        </style>
        
        <div class="" style="">
          <div class="">
            <p>${options.alerta.tipo}</p>
          </div>
        </div>
       
          `}, { direction: "top" });
      
      marker.on('mouseover', function() { this.openTooltip(); });
      marker.on('mouseout', function() { this.closeTooltip(); });
    }else{
      marker.bindPopup(
        `
          <h4 class="card-title" style="text-align: center;">${options.alerta.tipo}</h4>
          <div class="card-text" style="text-align: center;">
            ${moment(options.alerta.data).fromNow()}
          </div>
        `
      );
    }
  }

  return marker;
};


const MarkerGenerico = (coordenadas, options) => {
  const icon = `${process.env.PUBLIC_URL}/images/mapa/generic-marker.png`;
  const retinaIcon = `${process.env.PUBLIC_URL}/images/mapa/generic-marker@2x.png`;
  return AbstractMarker(coordenadas, options, icon, retinaIcon);
};

const PulseMarker = (coordenadas, options) => {
  const icon = new DivIcon({
    className: 'css-icon',
    html: '<div class="gps_ring"></div>',
    iconSize: [200, 200],
    iconAnchor: [100, 100]
  });

  return new Marker(coordenadas, { ...options, icon, id: 'pulse-marker' });
};

const RoundMarker = (coordenadas, options) => {
  const icon = new DivIcon({
    className: 'css-icon',
    html: '<div class="ring"></div>',
    iconSize: [50, 50],
    iconAnchor: [25, 25]
  });

  return new Marker(coordenadas, { ...options, icon, id: 'round-marker' });
};

const MarkerEmergencia = (coordenadas, options, usuario) => {
  const icon = `${process.env.PUBLIC_URL}/images/mapa/pin_emergencia.svg`;
  const retinaIcon = `${process.env.PUBLIC_URL}/images/mapa/point-alerta@2x.png`;
  return AbstractMarker(coordenadas, options, icon, retinaIcon, usuario);
};

const MarkerCarroSuspeito = (coordenadas, options, usuario) => {
  const icon = `${process.env.PUBLIC_URL}/images/mapa/pin_carrosuspeito.svg`;
  const retinaIcon = `${process.env.PUBLIC_URL}/images/mapa/point-carro-suspeito@2x.png`;
  return AbstractMarker(coordenadas, options, icon, retinaIcon, usuario);
};

const MarkerContador = (coordenadas, options, usuario) => {
  const icon = `${process.env.PUBLIC_URL}/images/mapa/pin_grupo.svg`;
  const retinaIcon = `${process.env.PUBLIC_URL}/images/mapa/point-count@2x.png`;
  return AbstractMarker(coordenadas, options, icon, retinaIcon, usuario);
};

const MarkerContadorSelecionado = (coordenadas, options, usuario) => {
  const icon = `${process.env.PUBLIC_URL}/images/mapa/point-count-select.png`;
  const retinaIcon = `${process.env.PUBLIC_URL}/images/mapa/point-count-select@2x.png`;
  return AbstractMarker(coordenadas, options, icon, retinaIcon, usuario);
};

const MarkerDrogas = (coordenadas, options, usuario) => {
  const icon = `${process.env.PUBLIC_URL}/images/mapa/pin_drogas.svg`;
  const retinaIcon = `${process.env.PUBLIC_URL}/images/mapa/point-drogas@2x.png`;
  return AbstractMarker(coordenadas, options, icon, retinaIcon, usuario);
};

const MarkerPessoaSuspeita = (coordenadas, options, usuario) => {
  const icon = `${process.env.PUBLIC_URL}/images/mapa/pin_pessoasuspeita.svg`;
  const retinaIcon = `${process.env.PUBLIC_URL}/images/mapa/point-pessoa-suspeita@2x.png`;
  return AbstractMarker(coordenadas, options, icon, retinaIcon, usuario);
};

const MarkerRoubo = (coordenadas, options, usuario) => {
  const icon = `${process.env.PUBLIC_URL}/images/mapa/pin_roubo.svg`;
  const retinaIcon = `${process.env.PUBLIC_URL}/images/mapa/point-roubo@2x.png`;
  return AbstractMarker(coordenadas, options, icon, retinaIcon, usuario);
};

const MarkerVandalismo = (coordenadas, options, usuario) => {
  const icon = `${process.env.PUBLIC_URL}/images/mapa/pin_vandalismo.svg`;
  const retinaIcon = `${process.env.PUBLIC_URL}/images/mapa/point-vandalismo@2x.png`;
  return AbstractMarker(coordenadas, options, icon, retinaIcon, usuario);
};

const MarkerInformativo = (coordenadas, options, usuario) => {
  const icon = `${process.env.PUBLIC_URL}/images/mapa/pin_informativo.svg`;
  const retinaIcon = `${process.env.PUBLIC_URL}/images/mapa/point-vandalismo@2x.png`;
  return AbstractMarker(coordenadas, options, icon, retinaIcon, usuario);
};

const withPreviewPopup = (marker, options) => {
  marker.bindPopup(
    `
      <style>
        .leaflet-popup-content-wrapper {
          border-radius: 3px;
        }
        .leaflet-popup-content {
          width: 200px;
          margin: 0px;
        }
      </style>
      <div class="camera-thumb" style="margin: 0px; width: 200px; height: 200px; background: url(${getCameraThumb(options)});">
        <div class="description">
          <p>${options.description}</p>
        </div>
      </div>
    `
  );

  marker.on('mouseover', function() { this.openPopup(); });
  marker.on('mouseout', function() { this.closePopup(); });

  return marker;
};

const MarkerCamera = (coordenadas, options, usuario, onClick) => {
  const icon = `${process.env.PUBLIC_URL}/images/mapa/pin_camera.svg`;
  const retinaIcon = `${process.env.PUBLIC_URL}/images/mapa/point-camera@2x.png`;
  var marker = AbstractMarker(coordenadas, options, icon, retinaIcon, usuario, onClick);
  return withPreviewPopup(marker, options);
};

const MarkerCameraOff = (coordenadas, options, usuario, onClick) => {
  const icon = `${process.env.PUBLIC_URL}/images/mapa/pin_camera_off.svg`;
  const retinaIcon = `${process.env.PUBLIC_URL}/images/mapa/point-camera-select@2x.png`;
  var marker = AbstractMarker(coordenadas, options, icon, retinaIcon, usuario, onClick);
  return withPreviewPopup(marker, options);
}

const MarkerCameraSelecionada = (coordenadas, options) => {
  const icon = `${process.env.PUBLIC_URL}/images/mapa/point-camera-select.png`;
  const retinaIcon = `${process.env.PUBLIC_URL}/images/mapa/point-camera-select@2x.png`;
  var marker = AbstractMarker(coordenadas, { ...options, cameraSelecionada: true }, icon, retinaIcon);
  return withPreviewPopup(marker, options);
};

const MarkerViolencia = (coordenadas, options, usuario) => {
  const icon = `${process.env.PUBLIC_URL}/images/mapa/pin_violencia.svg`;
  const retinaIcon = `${process.env.PUBLIC_URL}/images/mapa/point-vandalismo@2x.png`;
  return AbstractMarker(coordenadas, options, icon, retinaIcon, usuario);
}

const MarkerAusencia = (coordenadas, options, usuario) => {
  const icon = `${process.env.PUBLIC_URL}/images/mapa/pin_ausencia.svg`;
  const retinaIcon = `${process.env.PUBLIC_URL}/images/mapa/point-vandalismo@2x.png`;
  return AbstractMarker(coordenadas, options, icon, retinaIcon, usuario);
}

const getPorTipo = (tipo, coordenadas, options, usuario) => {
  switch(tipo) {
    case 'Drogas': return MarkerDrogas(coordenadas, options, usuario);
    case 'Emergência': return MarkerEmergencia(coordenadas, options, usuario);
    case 'Roubo': return MarkerRoubo(coordenadas, options, usuario);
    case 'Pessoa Suspeita': return MarkerPessoaSuspeita(coordenadas, options, usuario);
    case 'Veículo Suspeito': return MarkerCarroSuspeito(coordenadas, options, usuario);
    case 'Vandalismo': return MarkerVandalismo(coordenadas, options, usuario);
    case 'Violencia': return MarkerViolencia(coordenadas, options, usuario);
    case 'Informativo': return MarkerInformativo(coordenadas, options, usuario);
    case 'Ausência': return MarkerAusencia(coordenadas, options, usuario);
    default: return MarkerGenerico(coordenadas, options);
  }
};

export {
  getPorTipo,
  PulseMarker,
  RoundMarker,
  MarkerEmergencia,
  MarkerCamera,
  MarkerCameraSelecionada,
  MarkerCarroSuspeito,
  MarkerContador,
  MarkerContadorSelecionado,
  MarkerDrogas,
  MarkerPessoaSuspeita,
  MarkerRoubo,
  MarkerViolencia,
  MarkerInformativo,
  MarkerVandalismo,
  MarkerCameraOff,
  MarkerAusencia,
};



// WEBPACK FOOTER //
// ./src/components/mapa/Marker.js